export const ONE_HOUR_IN_MILLISECONDS = 1000 * 3600;
export const ONE_DAY_IN_MILLISECONDS = 1000 * 3600 * 24;
export const ONE_WEEK_IN_MILLISECONDS = ONE_DAY_IN_MILLISECONDS * 7;

export const DAYS_MONEY_BACK_GUARANTEED = 30;
